import {
  Icon,
  TaskForm,
  getTranslatedText,
  AppContext,
  isAuthorised,
  CustomModal
} from '@nile/components';
import { useQuery } from '@apollo/client';
import { AccountClient } from '@nile/graphql';
import { GET_ROLE_PERMISSON } from '@nile/banyan/src/Graphql/Mutations/role';
import { Button, Modal } from '@superops/ui-design-system';
import { cloneDeep } from 'lodash';
import { PlusCircle } from '@styled-icons/fa-solid/PlusCircle';
import React, { useContext, useState } from 'react';
import { injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import TaskFromRevamp from '@nile/components/src/Forms/TaskFromRevamp.js';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Tooltip } from 'react-clone-tippy';

function NewTask(props) {
  const appContext = useContext(AppContext);
  const flags = useFlags();
  const newTaskRevamp = flags?.taskTimer;
  const { user } = appContext;
  // const roleFeatures = user?.role?.roleFeatureList || [];
  const [roleFeatures, setRoleFeatures] = useState(
    user?.role?.roleFeatureList || []
  );

  const {
    intl,
    data,
    isLink,
    name,
    hideIcon,
    noRender,
    icon,
    noName,
    module,
    details,
    className = '',
    showParent = false,
    onDeleteHandler,
    workItem
  } = props;

  const { loading: rolesLoading, error, data: projectRoles } = useQuery(
    GET_ROLE_PERMISSON,
    {
      variables: { roleId: data?.project?.loggedInUserRole?.roleId },
      client: AccountClient,
      fetchPolicy: 'network-only',
      skip: !!data?.ticket || !data?.project?.loggedInUserRole?.roleId,
      onCompleted({ getRolePermissions }) {
        const updatedFeatures = cloneDeep(roleFeatures);
        if (getRolePermissions?.roleFeatureList?.length) {
          getRolePermissions.roleFeatureList.forEach((role) => {
            const idx = updatedFeatures.findIndex(
              (feat) => feat.feature.key === role.feature.key
            );
            if (idx >= 0) {
              updatedFeatures[idx] = role;
            } else {
              updatedFeatures.push(role);
            }
          });
        }
        setRoleFeatures(updatedFeatures);
        // setCharts(getCharts.charts);
      }
    }
  );

  let isViewParentAuthorised = true;
  let isEditAuthorised = true;
  let isDeleteAuthorised = true;

  if (data?.ticket || data?.project) {
    let isTicketEditAuthorisedNew;
    let isTicketDeleteAuthorisedNew;
    let ticketViewPermission;

    if (
      data?.ticket?.loggedInUserAsFollower?.ticketPermission ||
      data?.ticketPermission
    ) {
      isTicketEditAuthorisedNew = data?.technician?.userId === user?.userId;
      isTicketDeleteAuthorisedNew = false;

      let permissionString =
        data?.ticket?.loggedInUserAsFollower?.ticketPermission ||
        data?.ticketPermission;

      ticketViewPermission = JSON.parse(permissionString)?.ticket
        ?.viewPermission;
    } else {
      isTicketEditAuthorisedNew = isAuthorised(roleFeatures, 'tickets.edit');
      isTicketDeleteAuthorisedNew = isTicketEditAuthorisedNew;
      ticketViewPermission = isTicketEditAuthorisedNew;
    }

    let isProjectEditAuthorised = isAuthorised(roleFeatures, 'task.edit');

    if (!!data?.project && data?.technician?.userId === user?.userId) {
      isProjectEditAuthorised = data?.technician?.userId === user?.userId;
    }

    isEditAuthorised = data?.ticket
      ? isTicketEditAuthorisedNew
      : isProjectEditAuthorised;

    const isProjectDeleteAuthorised = isAuthorised(roleFeatures, 'task.delete');

    isDeleteAuthorised = data?.ticket
      ? isTicketDeleteAuthorisedNew
      : isProjectDeleteAuthorised;

    isViewParentAuthorised = data?.ticket
      ? ticketViewPermission
      : isAuthorised(roleFeatures, 'project.view');
  }

  return (
    <>
      {!noRender && (
        <div className="ellipsis">
          <Tooltip
            title={
              !noName && (name || getTranslatedText(intl, 'common.create'))
            }
            delay={200}
            duration={250}
            position="bottom"
            inertia
            trigger="mouseenter"
            animation="shift"
            animateFill={false}
          >
            <Button
              id="newTask"
              secondary
              icon={props.icon}
              onClick={props.toggleSheetActive}
              plain={isLink}
              plainSecondary={props.isText}
              customClassName={className}
              primary={props?.primaryButton}
            >
              <div
                className={`${!hideIcon &&
                  !props.icon &&
                  'fx'} wrap ta-l actr ellipsis`}
              >
                {!hideIcon && !props.icon && (
                  <div className="mr-10 fx actr">
                    <SVGIcon name="Add" />
                  </div>
                )}
                {!noName && (name || getTranslatedText(intl, 'common.create'))}
              </div>
            </Button>
          </Tooltip>
        </div>
      )}
      <CustomModal
        open={props.state}
        onClose={props.toggleSheetActive}
        zIndex={517}
        locked={props?.locked}
        showCloseButton={false}
        large={newTaskRevamp}
        noScroll={newTaskRevamp}
      >
        {newTaskRevamp ? (
          <div className="task-form-revamp-wrapper">
            <TaskFromRevamp
              roleFeatures={roleFeatures}
              type={0}
              meta={{
                title: data
                  ? getTranslatedText(intl, 'admin.runbooks.tasks.editTask')
                  : getTranslatedText(intl, 'admin.runbooks.tasks.newTask')
              }}
              data={data}
              toggleSheetActive={props.toggleSheetActive}
              addOrUpdateTechGroup={props.addOrUpdateTechGroup}
              module={module}
              details={details}
              ticketViewPermission={isViewParentAuthorised}
              showParent={showParent}
              onDeleteHandler={onDeleteHandler}
              showDelete={data && isDeleteAuthorised}
              disableEdit={!isEditAuthorised}
              hideSections={props.hideSections || []}
              isTemplate={props.isTemplate}
              workItem={workItem}
              hideDelete={props?.hideDelete}
            />
          </div>
        ) : (
          <TaskForm
            roleFeatures={roleFeatures}
            type={0}
            meta={{
              title: data
                ? getTranslatedText(intl, 'admin.runbooks.tasks.editTask')
                : getTranslatedText(intl, 'admin.runbooks.tasks.newTask')
            }}
            data={data}
            toggleSheetActive={props.toggleSheetActive}
            addOrUpdateTechGroup={props.addOrUpdateTechGroup}
            module={module}
            details={details}
            ticketViewPermission={isViewParentAuthorised}
            showParent={showParent}
            onDeleteHandler={onDeleteHandler}
            showDelete={data && isDeleteAuthorised}
            disableEdit={!isEditAuthorised}
            hideSections={props.hideSections || []}
            isTemplate={props.isTemplate}
          />
        )}
      </CustomModal>
    </>
  );
}

export default injectIntl(NewTask);
